import React from 'react'
import RefundDetails from './RefundDetails';

const RectificationRefund = ({ details }) => {
  return (
    <RefundDetails receiptDetails={details} />
  )
}

export default RectificationRefund;